// Icons for the notification center — the four channels (tabs + Delivery
// column) and the row actions.
// Fills are `currentColor` so the caller controls the colour with a text
// utility (active #1A2332 / default #868DA6) instead of each state needing its
// own copy of the artwork.

export const EmailIcon = ({ size = 20, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M17.9973 5.30469C18.2883 5.11927 18.6752 5.20491 18.8607 5.49593C19.0461 5.78702 18.9605 6.1739 18.6695 6.35937L11.1768 11.1315C11.1696 11.1361 11.1622 11.1411 11.1548 11.1453C10.8053 11.3483 10.4082 11.4545 10.0041 11.4546C9.5998 11.4546 9.20216 11.3484 8.85256 11.1453C8.84528 11.1411 8.83851 11.136 8.8314 11.1315L1.3314 6.35937C1.04025 6.17411 0.954198 5.78794 1.13934 5.49674C1.32461 5.20559 1.71078 5.11954 2.00197 5.30469L9.48 10.0638C9.63891 10.1561 9.82032 10.2046 10.0041 10.2046C10.1877 10.2045 10.3678 10.156 10.5266 10.0638L17.9973 5.30469Z"
      fill="currentColor"
    />
    <path
      d="M17.7084 4.9987C17.7084 4.4234 17.242 3.95703 16.6667 3.95703H3.33335C2.75806 3.95703 2.29169 4.4234 2.29169 4.9987V14.9987C2.29169 15.574 2.75806 16.0404 3.33335 16.0404H16.6667C17.242 16.0404 17.7084 15.574 17.7084 14.9987V4.9987ZM18.9584 14.9987C18.9584 16.2644 17.9323 17.2904 16.6667 17.2904H3.33335C2.0677 17.2904 1.04169 16.2644 1.04169 14.9987V4.9987C1.04169 3.73305 2.0677 2.70703 3.33335 2.70703H16.6667C17.9323 2.70703 18.9584 3.73305 18.9584 4.9987V14.9987Z"
      fill="currentColor"
    />
  </svg>
);

export const WebAppIcon = ({ size = 20, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M16.875 4.9987C16.875 4.4234 16.4086 3.95703 15.8333 3.95703H4.16666C3.59136 3.95703 3.12499 4.4234 3.12499 4.9987V11.6654C3.12499 12.2407 3.59136 12.707 4.16666 12.707H15.8333C16.4086 12.707 16.875 12.2407 16.875 11.6654V4.9987ZM18.125 11.6654C18.125 12.931 17.099 13.957 15.8333 13.957H4.16666C2.901 13.957 1.87499 12.931 1.87499 11.6654V4.9987C1.87499 3.73305 2.901 2.70703 4.16666 2.70703H15.8333C17.099 2.70703 18.125 3.73305 18.125 4.9987V11.6654Z"
      fill="currentColor"
    />
    <path
      d="M18.3333 16.0404C18.6785 16.0404 18.9583 16.3202 18.9583 16.6654C18.9583 17.0105 18.6785 17.2904 18.3333 17.2904H1.66666C1.32148 17.2904 1.04166 17.0105 1.04166 16.6654C1.04166 16.3202 1.32148 16.0404 1.66666 16.0404H18.3333Z"
      fill="currentColor"
    />
  </svg>
);

export const MobileAppIcon = ({ size = 20, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M15.2083 3.33464C15.2083 2.75934 14.742 2.29297 14.1667 2.29297H5.83332C5.25803 2.29297 4.79166 2.75934 4.79166 3.33464V16.668C4.79166 17.2433 5.25803 17.7096 5.83332 17.7096H14.1667C14.742 17.7096 15.2083 17.2433 15.2083 16.668V3.33464ZM16.4583 16.668C16.4583 17.9336 15.4323 18.9596 14.1667 18.9596H5.83332C4.56767 18.9596 3.54166 17.9336 3.54166 16.668V3.33464C3.54166 2.06898 4.56767 1.04297 5.83332 1.04297H14.1667C15.4323 1.04297 16.4583 2.06898 16.4583 3.33464V16.668Z"
      fill="currentColor"
    />
    <path
      d="M10.0081 14.3763C10.3533 14.3763 10.6331 14.6561 10.6331 15.0013C10.6331 15.3465 10.3533 15.6263 10.0081 15.6263H9.99999C9.65481 15.6263 9.37499 15.3465 9.37499 15.0013C9.37499 14.6561 9.65481 14.3763 9.99999 14.3763H10.0081Z"
      fill="currentColor"
    />
  </svg>
);

export const EditIcon = ({ size = 16, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M14 12.8332C14.2761 12.8332 14.5 13.057 14.5 13.3332C14.5 13.6093 14.2761 13.8332 14 13.8332H7.99999C7.72384 13.8332 7.49999 13.6093 7.49999 13.3332C7.49999 13.057 7.72384 12.8332 7.99999 12.8332H14Z"
      fill="currentColor"
    />
    <path
      d="M12.8333 3.41536C12.8333 3.1727 12.7367 2.93985 12.5651 2.76823C12.3935 2.5966 12.1607 2.5 11.918 2.5C11.6753 2.5 11.4425 2.59661 11.2708 2.76823L3.26367 10.7754C3.16461 10.8744 3.09199 10.9971 3.05274 11.1315L2.57878 12.7539L4.20182 12.2806C4.33633 12.2414 4.45952 12.1687 4.5586 12.0697L12.5651 4.0625C12.7367 3.89092 12.8333 3.658 12.8333 3.41536ZM13.8333 3.41536C13.8333 3.92322 13.6312 4.41042 13.2721 4.76953L5.26563 12.7767C5.04757 12.9947 4.77785 13.154 4.48177 13.2402L2.56706 13.7988C2.42374 13.8406 2.27156 13.8437 2.12695 13.8066C1.98234 13.7696 1.85038 13.6941 1.74479 13.5885C1.63916 13.4829 1.56377 13.3504 1.52669 13.2057C1.48968 13.0611 1.49205 12.909 1.53386 12.7656L2.09245 10.8509C2.17882 10.5552 2.33873 10.2862 2.55664 10.0684L10.5638 2.0612C10.923 1.70204 11.41 1.5 11.918 1.5C12.4259 1.5 12.913 1.70204 13.2721 2.0612C13.6312 2.42035 13.8333 2.90748 13.8333 3.41536Z"
      fill="currentColor"
    />
    <path
      d="M9.64647 2.97964C9.84173 2.78438 10.1582 2.78438 10.3535 2.97964L12.3535 4.97964C12.5488 5.1749 12.5488 5.49141 12.3535 5.68667C12.1582 5.88193 11.8417 5.88193 11.6465 5.68667L9.64647 3.68667C9.45121 3.49141 9.45121 3.1749 9.64647 2.97964Z"
      fill="currentColor"
    />
  </svg>
);

export const SmsIcon = ({ size = 20, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M16.875 4.16667C16.875 3.8904 16.7652 3.62553 16.5698 3.43018C16.3745 3.23483 16.1096 3.125 15.8333 3.125H4.16667C3.8904 3.125 3.62553 3.23483 3.43018 3.43018C3.23483 3.62553 3.125 3.8904 3.125 4.16667V15.9912L5.39144 13.7248L5.48665 13.6466C5.58857 13.5787 5.70904 13.5417 5.83333 13.5417H15.8333C16.1096 13.5417 16.3745 13.4318 16.5698 13.2365C16.7652 13.0411 16.875 12.7763 16.875 12.5V4.16667ZM18.125 12.5C18.125 13.1078 17.8834 13.6905 17.4536 14.1203C17.0238 14.5501 16.4411 14.7917 15.8333 14.7917H6.09212L2.94189 17.9419C2.76316 18.1206 2.49427 18.1745 2.26074 18.0778C2.0272 17.9811 1.875 17.7528 1.875 17.5V4.16667C1.875 3.55888 2.11662 2.97616 2.54639 2.54639C2.97616 2.11662 3.55888 1.875 4.16667 1.875H15.8333C16.4411 1.875 17.0238 2.11662 17.4536 2.54639C17.8834 2.97616 18.125 3.55888 18.125 4.16667V12.5Z"
      fill="currentColor"
    />
  </svg>
);
